export default [
  {
    path: "/inseminasi-buatan/",
    component: () =>
      import("@/pages/inseminasi-buatan/inseminasi-buatan-list.vue"),
    meta: { title: "Daftar Inseminasi Buatan" },
  },
  {
    path: "/inseminasi-buatan/create",
    component: () =>
      import("@/pages/inseminasi-buatan/inseminasi-buatan-form.vue"),
    meta: { title: "Tambah Inseminasi Buatan" },
  },
  {
    path: "/inseminasi-buatan/detail/:id",
    component: () =>
      import("@/pages/inseminasi-buatan/inseminasi-buatan-detail.vue"),
    meta: { title: "Detail Inseminasi Buatan" },
  },
  {
    path: "/inseminasi-buatan/update/:id",
    component: () =>
      import("@/pages/inseminasi-buatan/inseminasi-buatan-update.vue"),
    meta: { title: "Update Inseminasi Buatan" },
  },
];
